/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgQueues = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.023 4.131H2.726V3h10.297v1.131ZM9.692 10.92V5.263h1.211v5.656H9.692v.001Zm-4.846 0V5.263h1.211v5.656H4.846v.001Zm2.423 0V5.263H8.48v5.656H7.27l-.001.001ZM2.172 7.525 1.086 6.511l.857-.8 2.548 2.38-2.548 2.38-.857-.8 1.086-1.014H0V7.525h2.172Zm11.509 0-1.086-1.014.857-.8L16 8.091l-2.548 2.38-.857-.8 1.086-1.014h-2.172V7.525h2.172Zm-.658 5.657H2.726V12.05h10.297v1.132Z"
}));

export default SvgQueues;